import React from "react";
import BannerContacto from "../components/BannerContacto";
import DireccionContacto from "../components/DireccionContacto";
import Header from "../components/Header";
import Footer from "../components/Footer";

export default function Contacto() {
  return (
    <main style={{ fontFamily: "Inter, Roboto, sans-serif", color: "#222", background: "#fff"}}>
        <Header />
        <BannerContacto /> 
        <DireccionContacto />
        <Footer />
    </main>
  );
}   